import { InternshipLocationsServiceInterface } from 'domain/services';
import {
  CreateInternshipLocationUseCaseInterface,
  DeleteInternshipLocationImageUseCaseInterface,
  DeleteInternshipLocationUseCaseInterface,
  GetAllInternshipLocationsUseCaseInterface,
  GetInternshipLocationByIdUseCaseInterface,
  UpdateInternshipLocationImageUseCaseInterface,
  UpdateInternshipLocationUseCaseInterface,
  VerifyInternshipResponsibleCpfUseCaseInterface,
  VerifyInternshipResponsibleEmailUseCaseInterface,
} from 'domain/usecases';

interface UseCasesInjection {
  getAllInternshipLocations: GetAllInternshipLocationsUseCaseInterface;
  createInternshipLocation: CreateInternshipLocationUseCaseInterface;
  updateInternshipLocation: UpdateInternshipLocationUseCaseInterface;
  deleteInternshipLocation: DeleteInternshipLocationUseCaseInterface;
  getInternshipLocationById: GetInternshipLocationByIdUseCaseInterface;
  verifyInternshipResponsibleCpf: VerifyInternshipResponsibleCpfUseCaseInterface;
  verifyInternshipResponsibleEmail: VerifyInternshipResponsibleEmailUseCaseInterface;
  updateInternshipLocationImage: UpdateInternshipLocationImageUseCaseInterface;
  deleteInternshipLocationImage: DeleteInternshipLocationImageUseCaseInterface;
}

export class InternshipLocationsService
  implements InternshipLocationsServiceInterface
{
  private readonly _getAllInternshipLocations: GetAllInternshipLocationsUseCaseInterface;
  private readonly _createInternshipLocation: CreateInternshipLocationUseCaseInterface;
  private readonly _updateInternshipLocation: UpdateInternshipLocationUseCaseInterface;
  private readonly _deleteInternshipLocation: DeleteInternshipLocationUseCaseInterface;
  private readonly _getInternshipLocationById: GetInternshipLocationByIdUseCaseInterface;
  private readonly _verifyInternshipResponsibleCpf: VerifyInternshipResponsibleCpfUseCaseInterface;
  private readonly _verifyInternshipResponsibleEmail: VerifyInternshipResponsibleEmailUseCaseInterface;
  private readonly _updateInternshipLocationImage: UpdateInternshipLocationImageUseCaseInterface;
  private readonly _deleteInternshipLocationImage: DeleteInternshipLocationImageUseCaseInterface;

  constructor(usecases: UseCasesInjection) {
    this._getAllInternshipLocations = usecases.getAllInternshipLocations;
    this._createInternshipLocation = usecases.createInternshipLocation;
    this._updateInternshipLocation = usecases.updateInternshipLocation;
    this._deleteInternshipLocation = usecases.deleteInternshipLocation;
    this._getInternshipLocationById = usecases.getInternshipLocationById;
    this._verifyInternshipResponsibleCpf =
      usecases.verifyInternshipResponsibleCpf;
    this._verifyInternshipResponsibleEmail =
      usecases.verifyInternshipResponsibleEmail;
    this._updateInternshipLocationImage =
      usecases.updateInternshipLocationImage;
    this._deleteInternshipLocationImage =
      usecases.deleteInternshipLocationImage;
  }

  getAllInternshipLocations(
    params: GetAllInternshipLocationsUseCaseInterface.Params,
  ): Promise<GetAllInternshipLocationsUseCaseInterface.Result> {
    return this._getAllInternshipLocations.execute(params);
  }

  createInternshipLocation(
    params: CreateInternshipLocationUseCaseInterface.Params,
  ): Promise<CreateInternshipLocationUseCaseInterface.Result> {
    return this._createInternshipLocation.execute(params);
  }

  updateInternshipLocation(
    params: UpdateInternshipLocationUseCaseInterface.Params,
  ): Promise<UpdateInternshipLocationUseCaseInterface.Result> {
    return this._updateInternshipLocation.execute(params);
  }

  getInternshipLocationById(
    params: GetInternshipLocationByIdUseCaseInterface.Params,
  ): Promise<GetInternshipLocationByIdUseCaseInterface.Result> {
    return this._getInternshipLocationById.execute(params);
  }

  deleteInternshipLocation(
    params: DeleteInternshipLocationUseCaseInterface.Params,
  ): Promise<DeleteInternshipLocationUseCaseInterface.Result> {
    return this._deleteInternshipLocation.execute(params);
  }

  verifyInternshipResponsibleCpf(
    params: VerifyInternshipResponsibleCpfUseCaseInterface.Params,
  ): Promise<VerifyInternshipResponsibleCpfUseCaseInterface.Result> {
    return this._verifyInternshipResponsibleCpf.execute(params);
  }

  verifyInternshipResponsibleEmail(
    params: VerifyInternshipResponsibleEmailUseCaseInterface.Params,
  ): Promise<VerifyInternshipResponsibleEmailUseCaseInterface.Result> {
    return this._verifyInternshipResponsibleEmail.execute(params);
  }

  updateInternshipLocationImage(
    params: UpdateInternshipLocationImageUseCaseInterface.Params,
  ): Promise<UpdateInternshipLocationImageUseCaseInterface.Result> {
    return this._updateInternshipLocationImage.execute(params);
  }

  deleteInternshipLocationImage(
    params: DeleteInternshipLocationImageUseCaseInterface.Params,
  ): Promise<DeleteInternshipLocationImageUseCaseInterface.Result> {
    return this._deleteInternshipLocationImage.execute(params);
  }
}
